import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../hooks/useAuth'
import { Send, Trash2 } from 'lucide-react'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

export default function Comments({ entityType, entityId }) {
  const { profile } = useAuth()
  const [comments, setComments] = useState([])
  const [text, setText]         = useState('')
  const [sending, setSending]   = useState(false)

  useEffect(() => { fetchComments() }, [entityId])

  async function fetchComments() {
    const { data } = await supabase
      .from('comments')
      .select('*, user:profiles!comments_user_id_fkey(full_name, role)')
      .eq('entity_type', entityType)
      .eq('entity_id', entityId)
      .order('created_at')
    setComments(data ?? [])
  }

  async function sendComment(e) {
    e.preventDefault()
    if (!text.trim()) return
    setSending(true)
    await supabase.from('comments').insert({
      entity_type: entityType,
      entity_id: entityId,
      user_id: profile.id,
      content: text.trim(),
    })
    setText('')
    fetchComments()
    setSending(false)
  }

  async function deleteComment(commentId) {
    await supabase.from('comments').delete().eq('id', commentId)
    setComments(c => c.filter(x => x.id !== commentId))
  }

  return (
    <div className="space-y-4">
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {comments.length === 0 ? (
          <p className="text-center text-sm text-gray-400 py-6">No hay comentarios aún. Sé el primero.</p>
        ) : comments.map(c => (
          <div key={c.id} className={`flex gap-3 ${c.user_id === profile.id ? 'flex-row-reverse' : ''}`}>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0 ${
              c.user?.role === 'client' ? 'bg-accent-400' : 'bg-brand-700'
            }`}>
              {c.user?.full_name?.charAt(0) ?? '?'}
            </div>
            <div className={`flex-1 max-w-[80%] ${c.user_id === profile.id ? 'items-end' : 'items-start'} flex flex-col`}>
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-gray-700">{c.user?.full_name}</span>
                <span className="text-xs text-gray-400">{format(new Date(c.created_at), 'd MMM · HH:mm', { locale: es })}</span>
                {c.user_id === profile.id && (
                  <button onClick={() => deleteComment(c.id)} className="text-gray-300 hover:text-red-400 ml-1"><Trash2 size={11} /></button>
                )}
              </div>
              <div className={`rounded-2xl px-4 py-2 text-sm ${
                c.user_id === profile.id
                  ? 'bg-brand-700 text-white rounded-tr-sm'
                  : 'bg-gray-100 text-gray-800 rounded-tl-sm'
              }`}>
                {c.content}
              </div>
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={sendComment} className="flex gap-2">
        <input
          value={text}
          onChange={e => setText(e.target.value)}
          className="input flex-1"
          placeholder="Escribe un comentario..."
          disabled={sending}
        />
        <button type="submit" disabled={sending || !text.trim()} className="btn-primary px-4">
          <Send size={16} />
        </button>
      </form>
    </div>
  )
}
